import styled from '@emotion/styled';

export const Container = styled.div`
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 32px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;

export const SectionTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 20px 0;
`;

export const ChartContainer = styled.div`
    position: relative;
    height: 400px;
    margin-bottom: 24px;
`;

export const SummarySection = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    padding-top: 16px;
    border-top: 1px solid #e5e7eb;
`;

export const SummaryCard = styled.div`
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 16px;
`;

export const SummaryLabel = styled.div`
    font-size: 12px;
    font-weight: 500;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
`;

export const SummaryValue = styled.div`
    font-size: 24px;
    font-weight: 700;
    color: #111827;
`;

export const SummarySubtext = styled.div`
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: 80px 20px;
    color: #6b7280;
`;

export const EmptyStateText = styled.p`
    font-size: 14px;
    margin: 0;
`;
